/* Marla · Ficha de producto (rediseño Buen Fin 2026) · parte 2 de 2.
   Galería, ayudas emergentes, 10% de primera compra, barra fija y arranque.
   Requiere marla-pdp.js (parte 1). */
(function () {
  'use strict';

  var MarlaPDP = window.MarlaPDP;
  if (!MarlaPDP) return;
  var applyDrawerPreview = MarlaPDP.utils.applyDrawerPreview;

  /* ---------- Galería ---------- */
  MarlaPDP.prototype.initGallery = function () {
    var self = this;
    var gallery = this.root.querySelector('[data-mj-gallery]');
    if (!gallery) return;
    this.track = gallery.querySelector('[data-mj-track]');
    this.slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-mj-slide]'));
    this.thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-mj-thumb]'));
    this.countEl = gallery.querySelector('[data-mj-count]');
    this.totalEl = gallery.querySelector('[data-mj-total]');
    this.current = 0;

    var prev = gallery.querySelector('[data-mj-prev]');
    var next = gallery.querySelector('[data-mj-next]');
    if (prev) prev.addEventListener('click', function () { self.goTo(self.visibleIndex(self.current) - 1); });
    if (next) next.addEventListener('click', function () { self.goTo(self.visibleIndex(self.current) + 1); });

    this.thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = self.slides.findIndex(function (s) { return s.getAttribute('data-media-id') === thumb.getAttribute('data-media-id'); });
        if (idx > -1) self.goToSlide(self.slides[idx]);
      });
    });

    var ticking = false;
    this.track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          self.syncFromScroll();
        });
      },
      { passive: true }
    );

    this.track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); self.goTo(self.visibleIndex(self.current) + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); self.goTo(self.visibleIndex(self.current) - 1); }
    });

    if (this.variant) this.showVariantMedia(this.variant, true);
  };

  MarlaPDP.prototype.visibleSlides = function () {
    return this.slides.filter(function (s) { return !s.hidden; });
  };

  MarlaPDP.prototype.visibleIndex = function (slideIndex) {
    var slide = this.slides[slideIndex];
    return Math.max(0, this.visibleSlides().indexOf(slide));
  };

  MarlaPDP.prototype.goTo = function (visibleIdx) {
    var visible = this.visibleSlides();
    if (!visible.length) return;
    var idx = (visibleIdx + visible.length) % visible.length;
    this.goToSlide(visible[idx]);
  };

  MarlaPDP.prototype.goToSlide = function (slide, instant) {
    if (!slide || !this.track) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var left = slide.offsetLeft - this.track.offsetLeft - parseFloat(getComputedStyle(this.track).paddingLeft || 0);
    this.track.scrollTo({ left: Math.max(0, left), behavior: instant || reduce ? 'auto' : 'smooth' });
    this.setCurrent(this.slides.indexOf(slide));
  };

  MarlaPDP.prototype.syncFromScroll = function () {
    var visible = this.visibleSlides();
    if (!visible.length) return;
    var pad = parseFloat(getComputedStyle(this.track).paddingLeft || 0);
    var x = this.track.scrollLeft + pad;
    var best = visible[0];
    var bestDist = Infinity;
    var trackLeft = this.track.offsetLeft;
    visible.forEach(function (s) {
      var d = Math.abs(s.offsetLeft - trackLeft - x);
      if (d < bestDist) { bestDist = d; best = s; }
    });
    this.setCurrent(this.slides.indexOf(best));
  };

  MarlaPDP.prototype.setCurrent = function (slideIndex) {
    if (slideIndex < 0) return;
    this.current = slideIndex;
    var visible = this.visibleSlides();
    var pos = visible.indexOf(this.slides[slideIndex]) + 1;
    if (this.countEl) this.countEl.textContent = pos;
    if (this.totalEl) this.totalEl.textContent = visible.length;
    var id = this.slides[slideIndex].getAttribute('data-media-id');
    this.thumbs.forEach(function (t) {
      if (t.getAttribute('data-media-id') === id) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
  };

  /* Muestra la foto de la variante. Si las fotos tienen el color en su texto
     alternativo (alt), deja solo las de ese color. */
  MarlaPDP.prototype.showVariantMedia = function (variant, instant) {
    if (!this.slides || !this.slides.length) return;
    var optionValues = [];
    this.product.options.forEach(function (_, idx) {
      var values = [];
      this.product.variants.forEach(function (v) {
        if (values.indexOf(v.options[idx]) === -1) values.push(v.options[idx]);
      });
      optionValues = optionValues.concat(values.map(function (x) { return String(x).toLowerCase(); }));
    }, this);
    var chosen = variant.options.map(function (x) { return String(x).toLowerCase(); });
    var tagged = this.slides.filter(function (s) {
      var alt = s.getAttribute('data-alt') || '';
      return optionValues.some(function (val) { return val && alt.indexOf(val) > -1; });
    });

    if (tagged.length) {
      this.slides.forEach(function (s) {
        var alt = s.getAttribute('data-alt') || '';
        var hasAnyValue = optionValues.some(function (val) { return val && alt.indexOf(val) > -1; });
        var hasChosen = chosen.some(function (val) { return alt.indexOf(val) > -1; });
        s.hidden = hasAnyValue && !hasChosen;
      });
      this.thumbs.forEach(function (t) {
        var slide = this.slides.find(function (s) { return s.getAttribute('data-media-id') === t.getAttribute('data-media-id'); });
        if (t.parentElement) t.parentElement.hidden = !!(slide && slide.hidden);
      }, this);
    }

    var target = null;
    if (variant.featured_media) {
      var mediaId = String(variant.featured_media.id);
      target = this.slides.find(function (s) { return s.getAttribute('data-media-id') === mediaId && !s.hidden; });
    }
    if (!target) target = this.visibleSlides()[0];
    this.goToSlide(target, instant);
  };

  /* ---------- Ayudas emergentes ---------- */
  MarlaPDP.prototype.initPopovers = function () {
    var root = this.root;
    root.querySelectorAll('[data-mj-pop-btn]').forEach(function (btn) {
      var pop = root.querySelector('#' + btn.getAttribute('data-mj-pop-btn'));
      if (!pop) return;
      var close = function (returnFocus) {
        pop.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', outside, true);
        if (returnFocus) btn.focus();
      };
      var outside = function (event) {
        if (!pop.contains(event.target) && !btn.contains(event.target)) close(false);
      };
      btn.addEventListener('click', function () {
        if (!pop.hidden) { close(false); return; }
        pop.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        pop.focus({ preventScroll: true });
        setTimeout(function () { document.addEventListener('click', outside, true); });
      });
      pop.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { event.stopPropagation(); close(true); }
      });
      pop.querySelectorAll('[data-mj-pop-close]').forEach(function (x) {
        x.addEventListener('click', function () { close(true); });
      });
    });
  };

  /* ---------- 10% primera compra (fuera de Buen Fin) ---------- */
  MarlaPDP.prototype.initWelcome = function () {
    var form = this.root.querySelector('[data-mj-welcome]');
    if (!form) return;
    var ok = this.root.querySelector('[data-mj-welcome-ok]');
    var error = form.querySelector('[data-mj-welcome-error]');
    var input = form.querySelector('input[type="email"]');
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(email)) {
        error.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      error.hidden = true;
      input.removeAttribute('aria-invalid');
      var button = form.querySelector('button[type="submit"]');
      button.disabled = true;
      var done = function () {
        form.hidden = true;
        if (ok) ok.hidden = false;
      };
      fetch(form.getAttribute('action'), { method: 'POST', body: new FormData(form) }).then(done).catch(done);
    });
  };

  /* ---------- Barra fija (móvil) ---------- */
  MarlaPDP.prototype.initSticky = function () {
    var self = this;
    this.sticky = this.root.querySelector('[data-mj-sticky]');
    if (!this.sticky || !this.atc || !window.IntersectionObserver) return;
    var btn = this.sticky.querySelector('[data-mj-sticky-btn]');
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      self.sticky.hidden = !past;
      document.documentElement.classList.toggle('mj-sticky-on', past);
    }).observe(this.atc);
    btn.addEventListener('click', function () {
      if (!self.variant) {
        self.showNudge();
        return;
      }
      if (!self.variant.available) return;
      if (self.form.requestSubmit) self.form.requestSubmit(self.atc);
      else self.atc.click();
    });
  };

  MarlaPDP.prototype.renderSticky = function () {
    if (!this.sticky) return;
    var v = this.variant;
    var name = this.sticky.querySelector('[data-mj-sticky-name]');
    var price = this.sticky.querySelector('[data-mj-sticky-price]');
    var btn = this.sticky.querySelector('[data-mj-sticky-btn]');
    var multi = this.fieldsets.length > 0;
    if (name) name.textContent = this.product.title + (v && multi ? ' · ' + v.title : '');
    var now = this.root.querySelector('[data-mj-now]');
    if (price && now) price.textContent = now.textContent;
    if (btn) {
      if (v && !v.available) {
        btn.textContent = 'Agotado';
        btn.disabled = true;
      } else {
        btn.disabled = false;
        btn.textContent = v ? this.config.atc || 'Agregar al carrito' : this.config.chooseLabel || 'Elegir opción';
      }
    }
  };

  function boot() {
    document.querySelectorAll('[data-mj-pdp]').forEach(function (root) {
      if (root.__mjPdp) return;
      root.__mjPdp = new MarlaPDP(root);
    });
    applyDrawerPreview();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(applyDrawerPreview).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();